
import { defineComponent } from "vue";
import { IComponentsNavigationBarConfig } from "../types";
import CustomLabel from "../components/inputs/CustomLabel.vue";
import KeyValueRow from "../components/layout/KeyValueRow.vue";
import Card from "../components/layout/Card.vue";
import EditIcon from "../components/icons/EditIcon.vue";
import CheckmarkIcon from "../components/icons/CheckmarkIcon.vue";
import WarningIcon from "../components/icons/WarningIcon.vue";
import RunTime from "../components/time/RunTime.vue";
import TimeToggleButton from "../components/time/TimeToggleButton.vue";
import SetTimeButton from "../components/time/SetTimeButton.vue";

import { competitionIdToReadableName } from "../helpers/formatting";

export default defineComponent({
  name: "Run3PreRun",
  components: { CustomLabel, KeyValueRow, Card, EditIcon, CheckmarkIcon, WarningIcon, RunTime, TimeToggleButton, SetTimeButton },
  data() {
    return {
      vEvacuationPoint: "",
      vTeamShowedUp: false,
    };
  },
  computed: {
    selectedEvacuationPoint(): string {
      return this.$store.state.currentRun.scoring.evacuationPoint === "low"
        ? this.tg("epLow")
        : this.$store.state.currentRun.scoring.evacuationPoint === "high"
        ? this.tg("epHigh")
        : "?";
    },
    competitionName(): string {
      return competitionIdToReadableName(this.$store.state.currentRun.competition || "");
    },
  },
  methods: {
    tc(key: string): string {
      return this.$t("run.preRun." + key);
    },
    tg(key: string): string {
      return this.$t("general." + key);
    },
    getNavigationBarConfig(): IComponentsNavigationBarConfig {
      return {
        disableDrawerSwipeGestures: true,
        backButtonInsteadOfDrawer: true,
        backButtonRoute: "/run/team",
      };
    },
    goToLogin(): void {
      this.$router.push("/login");
    },
    backToSetup(): void {
      this.$router.push("/run/setup");
    },
    backToTeamSelection(): void {
      this.$router.push("/run/team");
    },
    continueToRun(): void {
      // TODO: show warning if "team showed up" is not checked?
      this.$router.push("/run/run");
    },
  },
  mounted() {
    if (
      !(
        this.$store.state.currentRun.competition &&
        this.$store.state.currentRun.arenaId &&
        this.$store.state.currentRun.round &&
        this.$store.state.currentRun.teamId
      )
    ) {
      this.$router.push("/run/team");
    }

    if (this.$store.state.currentRun.competition === "line-entry") {
      this.$store.commit("setEvacuationPoint", "low");
    }
    this.vEvacuationPoint = this.$store.state.currentRun.scoring.evacuationPoint || "";

    this.vTeamShowedUp = this.$store.state.currentRun.scoring.teamStarted;
  },
  watch: {
    vEvacuationPoint(ep: "low" | "high") {
      this.$store.commit("setEvacuationPoint", ep);
    },
    vTeamShowedUp(showedUp: boolean) {
      this.$store.commit("setTeamStarted", showedUp);
    },
  },
});
